/*:: type DestinationType = 'webhook';*/

// Only one type right now
class Destination {
  /*:: static fromJson: (Object) => Destination; */

  /*:: static serialize: (Destination) => Object; */
  constructor(id
  /*: ?string*/
  , type
  /*: DestinationType*/
  , url
  /*: string*/
  , config
  /*: Object*/
  ) {
    this.id = id;
    this.type = type;
    this.url = url;
    this.config = config;
  }

}

Destination.fromJson = (json
/*: Object*/
) =>
/*: Destination*/
new Destination(json.id, json.type, json.url, json.config);

Destination.serialize = data => (
/*: Object*/
{
  type: data.type,
  url: data.url,
  config: { ...data.config,
    format: data.config.format || 'v2'
  }
});

module.exports = Destination;